type WhitelabelTheme = {
  brand: string;
  primary: string;
  primaryDeep: string;
  primarySoft: string;
  primaryInk: string;
  canvas: string;
  accent: string;
  logoText: { left: string; right: string };
  supportEmail: string;
  partner?: string;
};

const DEFAULT_THEME: WhitelabelTheme = {
  brand: 'CanaBiz',
  primary: '#2d6a4f',
  primaryDeep: '#143d2c',
  primarySoft: '#e3efe6',
  primaryInk: '#ffffff',
  canvas: '#f6f3ec',
  accent: '#5b3a9a',
  logoText: { left: 'Cana', right: 'Biz' },
  supportEmail: 'contato@rogpe.tech',
};

const PARTNERS: Record<string, Partial<WhitelabelTheme>> = {
  'clinic-aurora': {
    brand: 'Aurora Cuidado',
    primary: '#3b5fb1',
    primaryDeep: '#1f3568',
    primarySoft: '#dde7f6',
    accent: '#b47834',
    logoText: { left: 'Aurora', right: 'Cuidado' },
    supportEmail: 'contato@aurora.cuidado',
    partner: 'clinic-aurora',
  },
  'farma-verde': {
    brand: 'FarmaVerde',
    primary: '#2f8a4d',
    primaryDeep: '#1a4d2b',
    primarySoft: '#dff0e3',
    logoText: { left: 'Farma', right: 'Verde' },
    supportEmail: 'help@farmaverde.app',
    partner: 'farma-verde',
  },
};

const detectPartner = (): string | null => {
  if (typeof window === 'undefined') return null;
  const param = new URLSearchParams(window.location.search).get('partner');
  if (param) {
    window.localStorage.setItem('canapyra-partner', param);
    return param;
  }
  const stored = window.localStorage.getItem('canapyra-partner');
  if (stored) return stored;

  const sub = window.location.hostname.split('.')[0];
  return sub && PARTNERS[sub] ? sub : null;
};

export const currentTheme = (): WhitelabelTheme => {
  const partner = detectPartner();
  const override = partner ? PARTNERS[partner] : null;
  return override ? { ...DEFAULT_THEME, ...override } : DEFAULT_THEME;
};

export const applyTheme = (): void => {
  const theme = currentTheme();
  const root = document.documentElement;
  root.style.setProperty('--primary', theme.primary);
  root.style.setProperty('--primary-deep', theme.primaryDeep);
  root.style.setProperty('--primary-soft', theme.primarySoft);
  root.style.setProperty('--primary-ink', theme.primaryInk);
  root.style.setProperty('--accent', theme.accent);
  if (theme.brand) document.title = theme.brand;
};
